import { useContext, useEffect, useState } from "react"
import { AppContext } from "@utils/AppContext";
import { Carousel, Spin, Button, Space, message,ConfigProvider } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import AntdTable from "./AntdTable/Table";
import api from "../../../api/api";
//需求页
export default function ImageService() {
    const { updateConfig } = useContext(AppContext);

    useEffect(() => {
        updateConfig({ sidebarKey: 1 })
    }, [])

    // const onChange = (currentSlide) => {
    //     console.log(currentSlide);
    // };
    const [totalOrder, setTotalOrder] = useState();//累计订单
    const [totalFinishedArtifact, setTotalFinishedArtifact] = useState();//累计交付
    const [totalRefinedArtifact, setTotalRefinedArtifact] = useState();//累计精修
    const [totalArtifact, setTotalArtifact] = useState();//累计底片
    const [isSpinning, setisSpinning] = useState(false)

    const handleDashboardInfo = async () => {
        try {
            const response = await api.dashboardInfo();
            const rawData = response.data;
            setTotalOrder(rawData.totalOrder);//累计订单
            setTotalArtifact(rawData.totalArtifact);//累计底片  
            setTotalFinishedArtifact(rawData.totalFinishedArtifact);//累计成片
            setTotalRefinedArtifact(rawData.totalRefinedArtifact);//累计精修
        } catch (error) {
            message.error(response.message)
            console.log(error);
        }
    }
    useEffect(() => {
        handleDashboardInfo();
    }, [])

    const getisSpinning = (flag) => {
        setisSpinning(flag)
    }

    return (
        <div className={styles.imageService_container}>
            <Spin spinning={isSpinning}>
                <div className={styles.head_contaner}>
                    {/* 轮播图左边的信息 */}
                    <div className={styles.head_info_container}>
                        <div className={styles.head_info}>
                            <span className={styles.head_detail}>{totalOrder} <span className={styles.head_detial_text}>件</span></span>
                            <span className={styles.head_detail}>{totalArtifact}<span className={styles.head_detial_text}>张</span></span>
                            <span className={styles.head_detail}>{totalFinishedArtifact} <span className={styles.head_detial_text}>张</span></span>
                            <span className={styles.head_detail}>{totalRefinedArtifact} <span className={styles.head_detial_text}>张</span></span>
                        </div>
                        <div className={styles.head_label}>
                            <span>已完成订单</span>
                            <span>累计交付底片</span>
                            <span>已下载成片</span>
                            <span>累计精修</span>
                        </div>
                    </div>
                    {/* 轮播图 */}
                    {/* <Carousel className={styles.carousel_head} autoplay={true}>
                        <div>
                            <img src={require('@assets/images/big_banner1.png')} alt="" className={styles.big_banner}/>
                        </div>
                        <div>
                            <img src={require('@assets/images/big_banner1.png')} alt="" className={styles.big_banner}/>
                        </div>
                    </Carousel> */}
                    <img src={require('@assets/images/big_banner1.png')} alt="" className={styles.big_banner}/>

                </div>

                <div className={styles.request_title}>订单</div>
                <AntdTable getisSpinning={getisSpinning} />
            </Spin>
        </div>

    );
}